/**
 * 试卷api
 * 试卷api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../course_standard/model/CreatedVo';
import PagingPaperVo from '../../course_standard/model/PagingPaperVo';
import PaperCreateForm from '../../course_standard/model/PaperCreateForm';
import PaperEditForm from '../../course_standard/model/PaperEditForm';
import PaperSectionCreateForm from '../../course_standard/model/PaperSectionCreateForm';
import PaperSectionRuleCreateForm from '../../course_standard/model/PaperSectionRuleCreateForm';
import PaperSectionRuleVo from '../../course_standard/model/PaperSectionRuleVo';
import PaperSectionUpdateForm from '../../course_standard/model/PaperSectionUpdateForm';
import PaperSectionVo from '../../course_standard/model/PaperSectionVo';
import UpdatedVo from '../../course_standard/model/UpdatedVo';
  /**
   * Paper service.
   * @module course_standard/api/PaperApi
   * @version 0.2.0
   */

  /**
   * Constructs a new PaperApi. 
   * @alias module:course_standard/api/PaperApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 创建考试试卷
     * @param {module:course_standard/model/PaperCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/CreatedVo}
     */
this.createPaper = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling createPaper";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/paper/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 新建试卷小节
     * @param {module:course_standard/model/PaperSectionCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/CreatedVo}
     */
this.createPaperSection = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling createPaperSection";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/paper/paper_section', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 新建试卷小节
     * @param {module:course_standard/model/PaperSectionRuleCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/CreatedVo}
     */
this.createPaperSectionRule = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling createPaperSectionRule";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/paper/paper_section_rule', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除碎片
     * @param {Integer} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.deletePaper = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deletePaper";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/paper/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除试卷小节
     * @param {Integer} paperSectionId paperSectionId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.deletePaperSection = function(paperSectionId) {
      var postBody = null;

      // verify the required parameter 'paperSectionId' is set
      if (paperSectionId == undefined || paperSectionId == null) {
        throw "Missing the required parameter 'paperSectionId' when calling deletePaperSection";
      }


      var pathParams = {
        'paperSectionId': paperSectionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/paper/paper_section/{paperSectionId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除试卷小节
     * @param {Integer} paperSectionRuleId paperSectionRuleId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.deletePaperSectionRule = function(paperSectionRuleId) {
      var postBody = null;

      // verify the required parameter 'paperSectionRuleId' is set
      if (paperSectionRuleId == undefined || paperSectionRuleId == null) {
        throw "Missing the required parameter 'paperSectionRuleId' when calling deletePaperSectionRule";
      }


      var pathParams = {
        'paperSectionRuleId': paperSectionRuleId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/paper/paper_section_rule/{paperSectionRuleId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查找试卷
     * @param {Integer} courseStandardId 课程标准id
     * @param {Integer} page 当前页
     * @param {Object} opts Optional parameters
     * @param {String} opts.name 试卷名称
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/PagingPaperVo}
     */
this.findPagingPaper = function(courseStandardId, page, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'courseStandardId' is set
      if (courseStandardId == undefined || courseStandardId == null) {
        throw "Missing the required parameter 'courseStandardId' when calling findPagingPaper";
      }

      // verify the required parameter 'page' is set
      if (page == undefined || page == null) {
        throw "Missing the required parameter 'page' when calling findPagingPaper";
      }


      var pathParams = {
      };
      var queryParams = {
        'courseStandardId': courseStandardId,
        'name': opts['name'],
        'page': page
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingPaperVo;
      return this.apiClient.callApi(
        '/api/paper/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 用户考试试卷
     * @param {Integer} paperId paperId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:course_standard/model/PaperSectionVo>}
     */
this.getPaperSectionList = function(paperId) {
      var postBody = null;

      // verify the required parameter 'paperId' is set
      if (paperId == undefined || paperId == null) {
        throw "Missing the required parameter 'paperId' when calling getPaperSectionList";
      }


      var pathParams = {
      };
      var queryParams = {
        'paperId': paperId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [PaperSectionVo];
      return this.apiClient.callApi(
        '/api/paper/paper_section', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 用户考试试卷
     * @param {Integer} paperSectionId paperSectionId
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:course_standard/model/PaperSectionRuleVo>}
     */
this.getPaperSectionRuleList = function(paperSectionId) {
      var postBody = null;

      // verify the required parameter 'paperSectionId' is set
      if (paperSectionId == undefined || paperSectionId == null) {
        throw "Missing the required parameter 'paperSectionId' when calling getPaperSectionRuleList";
      }


      var pathParams = {
      };
      var queryParams = {
        'paperSectionId': paperSectionId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [PaperSectionRuleVo];
      return this.apiClient.callApi(
        '/api/paper/paper_section_rule', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 随机生成题目
     * @param {Integer} id user exam id
     * @param {Integer} randomNum 随机组卷数量，固定选题组卷不填
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.randomGenerateDrill = function(id, randomNum) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling randomGenerateDrill";
      }

      // verify the required parameter 'randomNum' is set
      if (randomNum == undefined || randomNum == null) {
        throw "Missing the required parameter 'randomNum' when calling randomGenerateDrill";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'randomNum': randomNum
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/paper/{id}/random_generate_drill', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改试卷命名
     * @param {Integer} id id
     * @param {module:course_standard/model/PaperEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.updatePaper = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updatePaper";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updatePaper";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/paper/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改试卷小节
     * @param {Integer} paperSectionId paperSectionId
     * @param {module:course_standard/model/PaperSectionUpdateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:course_standard/model/UpdatedVo}
     */
this.updatePaperSection = function(paperSectionId, body) {
      var postBody = body;

      // verify the required parameter 'paperSectionId' is set
      if (paperSectionId == undefined || paperSectionId == null) {
        throw "Missing the required parameter 'paperSectionId' when calling updatePaperSection";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updatePaperSection";
      }


      var pathParams = {
        'paperSectionId': paperSectionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/paper/paper_section/{paperSectionId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
